/**
 * converts a map to a data URL to be set to an <img/> src attribute once the map finishes rendering
 *
 * @param map {Map}
 * @returns {Promise<string>}
 */
export function mapToSrc (map) {
    return new Promise(((resolve, reject) => {
        map.once('rendercomplete', () => {
            try {
                resolve(mapToSrcSync(map))
            } catch (e) {
                reject(e);
            }
        });
    }));
}

/**
 * converts a map to a data URL to be set to an <img/> src attribute
 * @param map {Map}
 * @returns {string}
 * @throws {SecurityError}
 */
export function mapToSrcSync (map) {
    return map.getTarget().querySelector('canvas').toDataURL()
}


export const transparentSrc = "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7";
